export const navItems = [
  { name: "home", link: "#home" },
  { name: "About", link: "#about" },
  { name: "Projects", link: "#projects" },
  { name: "skills", link: "#skills" },
  { name: "Contact", link: "#contact" },
];

export const gridItems = [
  {
    id: 1,
   
    title: "I prioritize client collaboration, fostering open communication ",
    description: "",
    className: "lg:col-span-3 md:col-span-6 md:row-span-4 lg:min-h-[60vh]",
    imgClassName: "w-full h-full",
    titleClassName: "justify-end",
    img: "/b1.svg",
    spareImg: "",
  },
  {
    id: 2,
    title: "I'm very flexible with time zone communications",
    description: "",
    className: "lg:col-span-2 md:col-span-3 md:row-span-2",
    imgClassName: "",
    titleClassName: "justify-start",
    img: "",
    spareImg: "",
  },
  {
    id: 3,
    title: "My tech stack",
    description: "I constantly try to improve",
    className: "lg:col-span-2 md:col-span-3 md:row-span-2",
    imgClassName: "",
    titleClassName: "justify-center",
    img: "",
    spareImg: "",
  },
  {
    id: 4,
    title: "Tech enthusiast with a passion for development.",
    description: "",
    className: "lg:col-span-2 md:col-span-3 md:row-span-1",
    imgClassName: "",
    titleClassName: "justify-start",
    img: "/grid.svg",
    spareImg: "/b4.svg",
  },

  {
    id: 5,
     "type":"web",
    title: "Currently building a JS Animation library",
    description: "The Inside Scoop",
    className: "md:col-span-3 md:row-span-2",
    imgClassName: "absolute right-0 bottom-0 md:w-96 w-60",
    titleClassName: "justify-center md:justify-start lg:justify-center",
    img: "/b5.svg",
    spareImg: "/grid.svg",
  },
  {
    id: 6,
    title: "Do you want to start a project together?",
    description: "",
    className: "lg:col-span-2 md:col-span-3 md:row-span-1",
    imgClassName: "",
    titleClassName: "justify-center md:max-w-full max-w-60 text-center",
    img: "",
    spareImg: "",
  },
];

export const projects = [
  {
    id: 1,
     "type":"web",
    title: "Real Estate Marketplace",
    des: "This real estate marketplace website provides a secure platform for users to browse",
    img: "../assets/state.png",
    iconLists: ["/re.svg", "/tail.svg", "/ts.svg", "/three.svg", "/fm.svg"],
    link: "https://github.com/HADJADJDAOUD/real-estate",
    people: [
      {
        id: 1,
        name: "Reactjs",
        designation: "",
        image: "../assets/react-2.svg",
      },
      {
        id: 2,
        name: "Nodejs",
        designation: "",
        image: "../assets/nodejs-2.svg",
      },
      {
        id: 3,
        name: "MongDb",
        designation: "",
        image: "../assets/mongodb-icon-2.svg",
      },
      {
        id: 4,
        name: "Tailwind CSS",
        designation: "",
        image: "../assets/tailwind.svg",
      },
    ],
  },
  {
    id: 2,
     "type":"web",
    title: "booking-app",
    des: "this project is a MERN Stack Reservation App about building a hotel reservation system",
    img: "../assets/booking.png",
    iconLists: ["/next.svg", "/tail.svg", "/ts.svg", "/stream.svg", "/c.svg"],
    link: "https://github.com/HADJADJDAOUD/booking-app",
    people: [
      {
        id: 1,
        name: "Reactjs",
        designation: "",
        image: "../assets/react-2.svg",
      },
      {
        id: 2,
        name: "Nodejs",
        designation: "",
        image: "../assets/nodejs-2.svg",
      },
      {
        id: 3,
        name: "MongDb",
        designation: "",
        image: "../assets/mongodb-icon-2.svg",
      },
      {
        id: 4,
        name: "Tailwind CSS",
        designation: "",
        image: "../assets/tailwind.svg",
      },
    ],
  },
  {
    id: 3,
     "type":"web",
    title: "social-media-app",
    des: "this social-media app where you can share posts and thoughts and gain new friendship with ease",
    img: "../assets/social.png",
    iconLists: ["/re.svg", "/tail.svg", "/ts.svg", "/three.svg", "/c.svg"],
    link: "https://github.com/HADJADJDAOUD/social-app",
    people: [
      {
        id: 1,
        name: "Reactjs",
        designation: "",
        image: "../assets/react-2.svg",
      },
      {
        id: 2,
        name: "Nodejs",
        designation: "",
        image: "../assets/nodejs-2.svg",
      },
      {
        id: 3,
        name: "MongDb",
        designation: "",
        image: "../assets/mongodb-icon-2.svg",
      },
      {
        id: 4,
        name: "Tailwind CSS",
        designation: "",
        image: "../assets/tailwind.svg",
      },
    ],
  },
  {
    id: 4,
     "type":"web",
    title: "shopping management sys",
    des: "a web where you can list and sell products and keep an eye of the progress",
    img: "../assets/shop.png",
    iconLists: ["/next.svg", "/tail.svg", "/ts.svg", "/three.svg", "/gsap.svg"],
    link: "https://github.com/HADJADJDAOUD/Shoping-management",
    people: [
      {
        id: 1,
        name: "Reactjs",
        designation: "",
        image: "../assets/react-2.svg",
      },
      {
        id: 2,
        name: "Nodejs",
        designation: "",
        image: "../assets/nodejs-2.svg",
      },
      {
        id: 3,
        name: "MongDb",
        designation: "",
        image: "../assets/mongodb-icon-2.svg",
      },
      {
        id: 4,
        name: "Tailwind CSS",
        designation: "",
        image: "../assets/tailwind.svg",
      },
    ],
  },
  {
    id: 5,
 "type":"web",
    title: "Brilliants",
    des: "a mobile application focusing in gathering the best algerian programmers and technicians",
    img: "../assets/brillinats.png",
    iconLists: ["/next.svg", "/tail.svg", "/ts.svg", "/three.svg", "/gsap.svg"],
    link: "https://github.com/HADJADJDAOUD/backend",
    people: [
      {
        id: 2,
        name: "Nodejs",
        designation: "",
        image: "../assets/nodejs-2.svg",
      },
      {
        id: 3,
        name: "MongDb",
        designation: "",
        image: "../assets/mongodb-icon-2.svg",
      },
      {
        id: 1,
        name: "Expressjs",
        designation: "",
        image: "../assets/express-js.jpg",
      },
    ],
  },
  {
    "id": 6,
     "type":"web",
    "title": "admin-dashboard",
    "des": "A feature-rich admin dashboard built with the MERN stack, offering seamless data visualization, user management, and deployment-ready capabilities.",
    "img": "../assets/Dashboard.png",
    "iconLists": ["/re.svg", "/mui.svg", "/rtkq.svg", "/node.svg", "/db.svg"],
    "link": "https://github.com/HADJADJDAOUD/Dashboard",
    "people": [
      {
        "id": 1,
        "name": "Reactjs",
        "designation": "",
        "image": "../assets/react-2.svg"
      },
      {
        "id": 2,
        "name": "Redux Toolkit",
        "designation": "",
        "image": "../assets/redux.svg"
      },
      {
        "id": 3,
        "name": "Nodejs",
        "designation": "",
        "image": "../assets/nodejs-2.svg"
      },
      {
        "id": 4,
        "name": "MongoDB",
        "designation": "",
        "image": "../assets/mongodb-icon-2.svg"
      },
    
    ]
  },
  {
    "id": 7,
  "type":"web",
    "title": "dashboard2",
    "des": "A feature-rich admin dashboard built with the MERN stack, offering seamless data visualization, user management, and deployment-ready capabilities.",
    "img": "../assets/dashboard2.png",
    "iconLists": ["/re.svg", "/mui.svg", "/rtkq.svg", "/node.svg", "/db.svg"],
    "link": "https://github.com/HADJADJDAOUD/Dashboard",
    "people": [
      {
        "id": 1,
        "name": "Reactjs",
        "designation": "",
        "image": "../assets/react-2.svg"
      },
      {
        "id": 2,
        "name": "Redux Toolkit",
        "designation": "",
        "image": "../assets/redux.svg"
      },
      {
        "id": 3,
        "name": "Nodejs",
        "designation": "",
        "image": "../assets/nodejs-2.svg"
      },
      {
        "id": 4,
        "name": "MongoDB",
        "designation": "",
        "image": "../assets/mongodb-icon-2.svg"
      },
    
    ]
  } ,
  {
    id: 8,
     "type":"web",
    title: "Delivery Food website",
    des: "a web where you can list and sell Food  and keep an eye of the progress and track them",
    img: "../assets/food.png",
    iconLists: ["/next.svg", "/tail.svg", "/ts.svg", "/three.svg", "/gsap.svg"],
    link: "https://github.com/HADJADJDAOUD/Food_delivery_web",
    people: [
      {
        id: 1,
        name: "Reactjs",
        designation: "",
        image: "../assets/react-2.svg",
      },
      {
        id: 2,
        name: "Nodejs",
        designation: "",
        image: "../assets/nodejs-2.svg",
      },
      {
        id: 3,
        name: "MongDb",
        designation: "",
        image: "../assets/mongodb-icon-2.svg",
      },
     
    ],
  },
  {
  id: 9,
  type: 'ai',
  title: 'Sentiment Analysis Model',
  des: 'A Python‑based sentiment analysis model that classifies text reviews into positive or negative sentiment using machine learning techniques.',
  img: '../assets/sentiment.png',           // add a thumbnail image in your assets
  iconLists: [
    '../assets/python.svg',
    '../assets/scikit-learn.svg',
    '../assets/pandas.svg',
    '../assets/numpy.svg',
    '../assets/nltk.svg'
  ],
  link: 'https://github.com/HADJADJDAOUD/sentiment-analysis',
  people: [
    { id: 1, name: 'Python',       designation: '', image: '../assets/python.svg' },
     { id: 2, name: 'Transformers',      designation: '', image: '../assets/transformers.png' },
    { id: 3, name: 'pandas',       designation: '', image: '../assets/pandas.svg' },
    { id: 4, name: 'NumPy',        designation: '', image: '../assets/numpy.svg' },
   
  ]
},
{
  id: 10,                           // update to next available ID
  type: 'ai',
  title: 'Hand Gesture Control with Voice Activation',
  des: ` control your computer's volume and
    screen brightness using hand gestures, with a sprinkle of voice command magic!`,
  img: '../assets/hand.png',    // add a thumbnail in your assets folder
  iconLists: [
    '../assets/python.svg',
    '../assets/opencv.svg',
    '../assets/mediapipe.svg',
    '../assets/pycaw.svg',
    '../assets/screen-brightness-control.svg',
    '../assets/speechrecognition.svg',
    '../assets/pyaudio.svg'
  ],
  link: 'https://github.com/HADJADJDAOUD/hand-gesture-control',
  people: [
    { id: 1, name: 'Python',                    designation: '', image: '../assets/python.svg' },
    { id: 2, name: 'OpenCV',                    designation: '', image: '../assets/opencv.svg' },
    { id: 3, name: 'MediaPipe',         designation: '', image: '../assets/media.png' },
  { id: 4, name: 'SpeechRecognition', designation: '', image: '../assets/speechrecognition.png' }
  ]
},
{
  id: 11,  
  type: 'ai',
  title: 'PDF AI Translator (French ↔ English)',
  des: 'An AI‑powered PDF translator that extracts text blocks and uses Facebook’s M2M100 model to translate between French and English.',
  img: '../assets/pdf-translator.png',           // add a thumbnail in your assets folder
  iconLists: [
    '../assets/python.svg',
    '../assets/transformers.svg',
    '../assets/pytorch.svg',
    '../assets/tqdm.svg'
  ],
  link: 'https://github.com/HADJADJDAOUD/pdf_ai_translator_french_eng',
  people: [
    { id: 1, name: 'Python',         designation: '', image: '../assets/python.svg' },
    { id: 2, name: 'Transformers',   designation: '', image: '../assets/transformers.png' },
    { id: 3, name: 'PyTorch',        designation: '', image: '../assets/pytorch.svg' },
  ]
},
{
  id: 12,  // use the next available ID
  type: 'ai',
  title: 'simpleRagApp – Chat with PDFs 📄💬',
  des: 'A Retrieval-Augmented Generation (RAG) app that lets you upload PDFs and ask   questions about their content using   Hugging Face models .',
  img: '../assets/chat_pdf.png', // add this thumbnail to your assets
  iconLists: [
    '../assets/python.svg',
    '../assets/langchain.svg',
    '../assets/streamlit.svg',
    '../assets/transformers.svg'
  ],
  link: 'https://github.com/HADJADJDAOUD/simpleRagApp-chat_pdf-',
  people: [
    { id: 1, name: 'LangChain',       designation: '', image: '../assets/langchain.svg' },
       { id: 2, name: 'Flask',            designation: '', image: '../assets/flask.svg' },
    { id: 3, name: 'Hugging Face Hub',designation: '', image: '../assets/Hugging.svg' },
    { id: 4, name: 'Python',          designation: '', image: '../assets/python.svg' }
  ]
},
];

export const workExperience = [
  {
    id: 1,
    title: "ReactJs",
    desc: "Assisted in the development of a web-based platform using React.js, enhancing interactivity.",
    className: "md:col-span-2",
    thumbnail: "/exp1.svg",
  },
  {
    id: 2,
    title: "Mobile App Dev - JSM Tech",
    desc: "Designed and developed mobile app for both iOS & Android platforms using React Native.",
    className: "md:col-span-2", // change to md:col-span-2
    thumbnail: "/exp2.svg",
  },
  {
    id: 3,
    title: "Freelance App Dev Project",
    desc: "Led the dev of a mobile app for a client, from initial concept to deployment on app stores.",
    className: "md:col-span-2", // change to md:col-span-2
    thumbnail: "/exp3.svg",
  },
  {
    id: 4,
    title: "Lead Frontend Developer",
    desc: "Developed and maintained user-facing features using modern frontend technologies.",
    className: "md:col-span-2",
    thumbnail: "../assets/p4.svg",
  },
];
export const skills = [
  {
    id: 1,
    title: "MERN Stack",
    desc: "Proficient in MongoDB, Express.js, React.js, and Node.js to build full-stack applications.",
    className: "flex-1 text-blue-700 border-slate-800",
    thumbnail: [
      "../assets/react-2.svg",
      "../assets/mongodb-icon-2.svg",
      "../assets/nodejs-2.svg",

      "../assets/tailwind.svg",
    ],
  },
  {
    id: 2,
    title: "Django",
    desc: "Experienced in developing backend services using Django framework with Python.",
    className: "flex-1 text-green-700 border-slate-800",
    thumbnail: ["../assets/django.svg"],
  },
  {
    id: 3,
    title: "Deep learning & ML",
    desc: "Experienced in building machine learning models using TensorFlow and NumPy.",
    className: "flex-1 text-purple-700 border-slate-800",
    thumbnail: ["../assets/tensorflow-2.svg", "../assets/numpy-1.svg",'../assets/Hugging.svg'],
  },
  {
    id: 4,
    title: "PowerPoint",
    desc: "Skilled in creating engaging presentations using Microsoft PowerPoint.",
    className: "flex-1 text-orange-700 border-slate-800",
    thumbnail: ["../assets/powerpoint-2.svg"],
  },
  {
    id: 5,
    title: "Quantum Computing",
    desc: "Familiar with quantum computing concepts and programming using Qiskit.",
    className: "flex-1 text-yellow-700 border-slate-800",
    thumbnail: ["../assets/quantum.svg"],
  },
];

export const socialMedia = [
  {
    id: 1,
    img: "../assets/github1.svg",
    link: "https://github.com/HADJADJDAOUD",
  },
  {
    id: 2,
    img: "../assets/instagram2.svg",
    link: "https://www.instagram.com/daoud_dx/",
  },
  {
    id: 3,
    img: "../assets/linkedin2.svg",
    link: "https://www.linkedin.com/in/daoud-hadjadj-0a5371267/",
  },
];
